/**
 * Function to get user's geolocation coordinates
 * 
 * @function getUserCoordinates
 * @returns {Promise} A promise that resolves with:
 *   - Array [latitude, longitude] on success
 *   - Rejects with error message if geolocation fails
 */
const getUserCoordinates = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject('Geolocation is not supported by this browser');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve([position.coords.latitude, position.coords.longitude]);
      },
      (error) => {
        let errorMessage;
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = 'User denied the request for geolocation';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = 'Location information is unavailable';
            break;
          case error.TIMEOUT:
            errorMessage = 'The request to get user location timed out';
            break;
          default:
            errorMessage = 'An unknown error occurred';
        }
        reject(errorMessage);
      },
      {
        // Always use most accurate method to get coordinates
        enableHighAccuracy: true,
        // timeout after 5 seconds of trying to get coordinates
        timeout: 5000,
        // always get the latest coordinates, not cached ones
        maximumAge: 0
      }
    );
  });
};

export default getUserCoordinates;